<template>
  <a-layout style="padding-top: 65px;">
    <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">

      <!-- 文档位置: 面包屑 -->
      <a-row :gutter="24">
        <a-breadcrumb separator=">" style="margin:0px 0px 20px 10px;">
          <!-- <a-breadcrumb-item>首页</a-breadcrumb-item> -->
          <a-breadcrumb-item>
            <router-link :to="'/admin/ebook'">
              电子书管理
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>文档管理</a-breadcrumb-item>
          <a-breadcrumb-item>{{ ebook.name }}</a-breadcrumb-item>
          <!-- <a-breadcrumb-item>{{ ebook.description }}</a-breadcrumb-item> -->
        </a-breadcrumb>
      </a-row>

      <!-- 文章节点&编辑器-->
      <a-row :gutter="24">
        <!--文档节点 -->
        <a-col :span="8">
          <!-- 查询按钮 -->
          <p>
            <a-form layout="inline" :model="param">
              <a-form-item>
                <a-button type="primary" @click="handleQuery()">
                  查询
                </a-button>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="add()">
                  新增
                </a-button>
              </a-form-item>
              <a-form-item>
                <!-- 新页面打开 -->
                <!-- 代码编码 window.open(routeUrl.href, '_blank'); -->
                <router-link :to="'/doc?ebookId=' + ebookId" slots="a" target="_blank">
                  <a-button type="primary">
                    详情
                  </a-button>
                </router-link>
              </a-form-item>
            </a-form>
          </p>

          <!-- 超出视图部分出现滚动条 -->
          <a-layout-sider width="100%"
            :style="{ overflow: 'auto', height: '90vh', width: '100vh', background: '#fff', position: 'relative', left: 0, right: 0, top: 0, bottom: 0 }">
            <!--  :row-key="record => record.id" -->
            <a-table v-if="level1.length > 0" :columns="columns" :data-source="level1" :loading="loading"
              :pagination="false" size="small" :defaultExpandAllRows="true"> <!--表格超出滚动 :scroll="{ y: 720 }"-->
              <template #sort="{ record }">
                {{ record.sort }}
              </template>
              <template #name="{ text }">
                {{ text }}
              </template>
              <template v-slot:action="{ record }"> <!--{ text, record }-->
                <a-space size="small">
                  <a-button type="primary" @click="edit(record)" size="small">
                    编辑
                  </a-button>
                  <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否" @confirm="handleDelete(record.id)">
                    <a-button type="primary" size="small" danger>
                      删除
                    </a-button>
                  </a-popconfirm>
                </a-space>
              </template>
            </a-table>
          </a-layout-sider>
        </a-col>
        <!--文档编辑器 -->
        <a-col :span="16">
          <p>
            <a-form layout="inline" :model="param">
              <a-form-item>
                <a-button type="primary" @click="handleSave()">
                  保存
                </a-button>
              </a-form-item>
            </a-form>
          </p>
          <a-form :model="doc" layout="vertical">
            <a-form-item>
              <a-input v-model:value="doc.name" placeholder="名称" :allowClear="true" />
            </a-form-item>
            <a-form-item>
              <!-- Warning: [ant-design-vue: TreeSelect] `replaceFields` is deprecated, please use fieldNames instead -->
              <!-- 默认展开所有：tree-default-expand-all -->
              <a-tree-select v-model:value="doc.parent" style="width: 100%" :allowClear="true"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="treeSelectData"
                placeholder="请选择父文档" :defaultExpandAll="false"
                :fieldNames="{ label: 'name', title: 'name', key: 'id', value: 'id' }">
              </a-tree-select>
            </a-form-item>
            <a-form-item>
              <a-input v-model:value="doc.sort" placeholder="顺序" :allowClear="true" />
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="handlePreviewContent()">
                <EyeOutlined />
                内容预览
              </a-button>
            </a-form-item>
            <a-form-item>
              <div id="content"></div>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>

      <!--预览抽屉框 -->
      <a-drawer width="900" placement="right" :closable="false" :visible="drawerVisible" @close="onDrawerClose">
        <div class="wangeditor" :innerHTML="previewHtml"></div>
      </a-drawer>
      
      <!-- 底部 -->
      <TheFooter></TheFooter>
      
    </a-layout-content>

  </a-layout>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref, createVNode } from 'vue';
import axios from 'axios';
import { message, Modal } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";
import ExclamationCircleOutlined from "@ant-design/icons-vue/ExclamationCircleOutlined";
import store from "@/store"
import TheFooter from "@/components/the-footer.vue";

// 引入公共样式
import '@/styles/mystyle.css'

/**
 * ！！！此版本 4.6.3
 * $ npm i wangeditor@4.6.3 --save
 */
import E from 'wangeditor'

// 引入highlight插件 highlight.min.js
// CDN方式引入需要申明变量
// declare let hljs: any;
import hljs from 'highlight.js'
import 'highlight.js/styles/xcode.css'
// xcode.css vs2015.css
// github-dark-dimmed.css github-dark.css github.css
// atom-one-dark-reasonable.css  
// a11y-dark.css ,  a11y-light.css
// kimbie-dark.css 
// tokyo-night-dark.css , tokyo-night-light.css
// googlecode.css
// an-old-hope.css
// devibeans.css, night-owl.css
// docco.css , felipec.css
// foundation.css, magula.css
// idea.css intellij-light.css
// panda-syntax-dark.css, pojoaque
// stackoverflow-dark.css, stackoverflow-light.css


export default defineComponent({
  name: 'AdminDoc',
  components: {
    TheFooter
  },
  setup() {
    const route = useRoute();
    console.log("路由：", route);
    console.log("route.path:", route.path);          // /admin/doc
    console.log("route.query:", route.query);        // {"ebookId": "2"}
    console.log("route.param:", route.params);       // {}
    console.log("route.fullPath:", route.fullPath);  // /admin/doc?ebookId=2
    console.log("route.name:", route.name);          // AdminDoc
    console.log("route.meta:", route.meta);          // {loginRequire: true}

    // 电子书ID
    const ebookId = ref(route.query.ebookId)
    const ebook = ref({ name: undefined })

    const param = ref();
    param.value = {};
    const docs = ref();
    const loading = ref(false);
    // 因为树选择组件的属性状态，会随当前编辑的节点而变化，所以单独声明一个响应式变量
    const treeSelectData = ref();
    treeSelectData.value = [];

    const columns = [
      {
        title: '序号',
        dataIndex: 'sort',
        slots: { customRender: 'sort' }
      },
      {
        title: '名称',
        dataIndex: 'name',
        slots: { customRender: 'name' }
      },
      {
        title: 'Action',
        key: 'action',
        slots: { customRender: 'action' }
      }
    ];

    /**
     * 一级文档树，children属性就是二级文档
     * [{
     *   id: "",
     *   name: "",
     *   children: [{
     *     id: "",
     *     name: "",
     *   }]
     * }]
     */
    const level1 = ref(); // 一级文档树，children属性就是二级文档
    level1.value = [];

    // 查询电子书详情
    // 电子书管理 > 	Vue 入门教程  >  前端开发 / Vue
    const handEbookQuery = () => {

      axios.get("/ebook/detail/" + route.query.ebookId).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          ebook.value = result.data;
          console.log("ebook ", ebook.value);
        } else {
          message.error(result.message);
        }
      });

    };

    /**
     * 数据查询
     **/
    const handleQuery = () => {
      loading.value = true;
      // 如果不清空现有数据，则编辑保存重新加载数据后，再点编辑，则列表显示的还是编辑前的数据
      level1.value = [];
      axios.get("/doc/all/" + route.query.ebookId).then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          docs.value = result.data.list;
          console.log("原始数组：", docs.value);

          level1.value = [];
          level1.value = Tool.array2Tree(docs.value, 0);
          console.log("树形结构：", level1);

          // 父文档下拉框初始化，相当于点击新增
          treeSelectData.value = Tool.copy(level1.value) || [];
          // 为选择树添加一个"无"
          treeSelectData.value.unshift({ id: 0, name: '无' });
        } else {
          message.error(result.message);
        }
      });
    };

    // -------- 表单 ---------
    const doc = ref();
    doc.value = {
      ebookId: route.query.ebookId
    };
    const modalVisible = ref(false);
    const modalLoading = ref(false);
    const editor = new E('#content');
    editor.config.zIndex = 0;
    // 显示上传图片按钮，转成Base64存储，同时也支持拖拽图片
    // 上传图片文档：https://doc.wangeditor.com/pages/07-%E4%B8%8A%E4%BC%A0%E5%9B%BE%E7%89%87/01-%E9%85%8D%E7%BD%AE%E6%9C%8D%E5%8A%A1%E7%AB%AF%E6%8E%A5%E5%8F%A3.html
    // 上传视频文档：https://doc.wangeditor.com/pages/07-%E4%B8%8A%E4%BC%A0%E8%A7%86%E9%A2%91/01-%E9%85%8D%E7%BD%AE%E6%9C%8D%E5%8A%A1%E7%AB%AF%E6%8E%A5%E5%8F%A3.html
    editor.config.uploadImgShowBase64 = true;

    const handleSave = () => {
      modalLoading.value = true;
      doc.value.content = editor.txt.html();
      axios.post("/doc/save", doc.value).then((response) => {
        modalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          // modalVisible.value = false;
          message.success("保存成功！");
          // 清空表单
          clearForm()
          // 重新加载列表
          handleQuery();
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 清空表单
     */
    const clearForm = () => {
      // 清空内容,不要清除ID
      doc.value.name = undefined
      doc.value.parent = undefined
      doc.value.sort = undefined
      editor.txt.html('')
    };

    /**
     * 将某节点及其子孙节点全部置为disabled
     */
    const setDisable = (treeSelectData: any, id: any) => {
      // console.log(treeSelectData, id);
      // 遍历数组，即遍历某一层节点
      for (let i = 0; i < treeSelectData.length; i++) {
        const node = treeSelectData[i];
        if (node.id === id) {
          // 如果当前节点就是目标节点
          console.log("disabled", node);
          // 将目标节点设置为disabled
          node.disabled = true;

          // 遍历所有子节点，将所有子节点全部都加上disabled
          const children = node.children;
          if (Tool.isNotEmpty(children)) {
            for (let j = 0; j < children.length; j++) {
              setDisable(children, children[j].id)
            }
          }
        } else {
          // 如果当前节点不是目标节点，则到其子节点再找找看。
          const children = node.children;
          if (Tool.isNotEmpty(children)) {
            setDisable(children, id);
          }
        }
      }
    };

    const deleteIds: Array<string> = [];
    const deleteNames: Array<string> = [];
    /**
     * 查找整根树枝
     */
    const getDeleteIds = (treeSelectData: any, id: any) => {
      // console.log(treeSelectData, id);
      // 遍历数组，即遍历某一层节点
      for (let i = 0; i < treeSelectData.length; i++) {
        const node = treeSelectData[i];
        if (node.id === id) {
          // 如果当前节点就是目标节点
          console.log("delete", node);
          // 将目标ID放入结果集ids
          // node.disabled = true;
          deleteIds.push(id);
          deleteNames.push(node.name);

          // 遍历所有子节点
          const children = node.children;
          if (Tool.isNotEmpty(children)) {
            for (let j = 0; j < children.length; j++) {
              getDeleteIds(children, children[j].id)
            }
          }
        } else {
          // 如果当前节点不是目标节点，则到其子节点再找找看。
          const children = node.children;
          if (Tool.isNotEmpty(children)) {
            getDeleteIds(children, id);
          }
        }
      }
    };

    /**
     * 内容查询
     **/
    const handleQueryContent = () => {
      axios.get("/doc/find-content/" + doc.value.id).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          editor.txt.html(result.data)
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 编辑
     */
    const edit = (record: any) => {
      // 清空富文本框
      editor.txt.html("");
      modalVisible.value = true;
      doc.value = Tool.copy(record);
      handleQueryContent();

      // 不能选择当前节点及其所有子孙节点，作为父节点，会使树断开
      treeSelectData.value = Tool.copy(level1.value);
      setDisable(treeSelectData.value, record.id);

      // 为选择树添加一个"无"
      treeSelectData.value.unshift({ id: 0, name: '无' });
    };

    /**
     * 新增
     */
    const add = () => {
      // 清空富文本框
      editor.txt.html("");
      modalVisible.value = true;
      doc.value = {
        ebookId: route.query.ebookId
      };

      treeSelectData.value = Tool.copy(level1.value) || [];

      // 为选择树添加一个"无"
      treeSelectData.value.unshift({ id: 0, name: '无' });

      console.log('treeSelectData => ', treeSelectData.value)
    };

    const handleDelete = (id: number) => {
      // console.log(level1, level1.value, id)
      // 清空数组，否则多次删除时，数组会一直增加
      deleteIds.length = 0;
      deleteNames.length = 0;
      getDeleteIds(level1.value, id);
      Modal.confirm({
        title: '重要提醒',
        icon: createVNode(ExclamationCircleOutlined),
        content: '将删除：【' + deleteNames.join("，") + "】删除后不可恢复，确认删除？",
        onOk() {
          // console.log(ids)
          axios.delete("/doc/delete/" + deleteIds.join(",")).then((response) => {
            const result = response.data; // data = commonResp
            if (result.code == 0 && result.message == 'success') {
              // 重新加载列表
              handleQuery();
            } else {
              message.error(result.message);
            }
          });
        },
      });
    };

    // ----------------富文本预览--------------
    const drawerVisible = ref(false);
    const previewHtml = ref();
    const handlePreviewContent = () => {
      const html = editor.txt.html();
      previewHtml.value = html;
      drawerVisible.value = true;
    };
    const onDrawerClose = () => {
      drawerVisible.value = false;
    };

    onMounted(() => {

      handEbookQuery();

      handleQuery();

      console.log('user --> ', store.state.user)

      // 创建编辑器
      // 配置编辑器的高度
      editor.config.height = 700  // 单位为px
      // 或者使用CSS选择器来指定容器
      // editor.customConfig.height = '500px'
      // editor.customConfig.height = '50%'

      // 挂载highlight插件 配置高亮插件
      // hljs.highlightAll()
      editor.highlight = hljs

      editor.create();
      // 设置编辑器高度 默认 300px
      // let eds: any = document.getElementsByClassName('w-e-text-container')
      // console.log('eds', eds)
      // console.log('eds array', Array.isArray(eds))
      // console.log('eds type', typeof (eds))
      // if (typeof (eds) == 'object') {
      //   eds[0].style = eds[0].style.cssText + 'height: 500px'
      //   console.log('eds.style', eds[0].style)
      //   console.log('eds.style.cssText ', eds[0].style.cssText)
      // }
      // console.log('=====eds=====', eds)

    });

    return {
      param,
      docs,
      level1,
      columns,
      loading,
      handleQuery,

      edit,
      add,

      doc,
      modalVisible,
      modalLoading,
      handleSave,

      handleDelete,

      treeSelectData,

      drawerVisible,
      previewHtml,
      handlePreviewContent,
      onDrawerClose,
      ebookId,
      ebook
    }
  }
});
</script>

<style scoped>
img {
  width: 50px;
  height: 50px;
}
</style>
